export const TOKEN = "token";
export const COMPANY_ID = "companyId";
export const PERMISSIONS = "permissions";
export const ROLE_NAME = "role_name";
export const COMPANY = "company";
export const PROJECT = "project";
export const PROFILE = "profile";
